import { BrowserRouter } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import AppRoutes from './routes'
import { useSessionInit } from './hooks/useSessionInit'
import { useAuthExpiry } from './hooks/useAuthExpiry'
import { useExchangeRatesAutoload } from './hooks/useExchangeRatesAutoload'

function AppInitializer() {
  useSessionInit()
  useAuthExpiry()
  useExchangeRatesAutoload()
  return null
}

function App() {
  return (
    <RecoilRoot>
      <BrowserRouter>
        <AppInitializer />
        <AppRoutes />
      </BrowserRouter>
    </RecoilRoot>
  )
}

export default App
